import adminApi from 'services/admin/adminApi';

/**
 * Fetches order search suggestions.
 * 
 * @param {Object} params - Search parameters
 * @param {string} params.term - Search term
 * @param {string|number} params.organisation_id - Organization ID
 * @returns {Promise<Object>} API response
 */
export const fetchOrderSuggestions = async ({ term, organisation_id }) => {
    return await adminApi.getSearchSuggestions('order-by-id', { term, organisation_id });
};
